module.exports = __webpack_public_path__ + "img/fzzximg.7b20408c.png";